module.exports = __webpack_public_path__ + "static/media/NoirPro-Light.bbd56c69.woff";